import { render, staticRenderFns } from "./orderCompact.vue?vue&type=template&id=6edcaf16&scoped=true&"
import script from "./orderCompact.vue?vue&type=script&lang=js&"
export * from "./orderCompact.vue?vue&type=script&lang=js&"
import style0 from "./orderCompact.vue?vue&type=style&index=0&id=6edcaf16&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6edcaf16",
  null
  
)

export default component.exports